// extracted by mini-css-extract-plugin
export var avatarContainer = "_9s-0";
export var avatarTypingWave = "_9s-i";
export var gray = "_9s-f";
export var green = "_9s-c";
export var icon = "_9s-9";
export var image = "_9s-1";
export var lg = "_9s-6";
export var md = "_9s-5";
export var presenceDot = "_9s-b";
export var red = "_9s-d";
export var sm = "_9s-4";
export var status = "_9s-a";
export var typingDot = "_9s-h";
export var typingPill = "_9s-g";
export var xl = "_9s-7";
export var xs = "_9s-3";
export var xxl = "_9s-8";
export var xxs = "_9s-2";
export var yellow = "_9s-e";